import PhotoGalleryPage from './Pages/PhotoGallery/index.js';

function App() {
    const params = new URLSearchParams(window.location.search);

    window.baseDomain = "https://squid-app-aychi.ondigitalocean.app/";
    window.defaultViewMode = "full-screen";

    const viewMode = params.get('viewMode') || window.defaultViewMode;
    const restaurantName = params.get('restaurantName') || '';
    const restaurantId = params.get("restaurantId") || 'demo';

    window.viewMode = viewMode;
    window.restaurantName = restaurantName;
    window.restaurantId = restaurantId;
    
    console.log(`View Mode set to: ${viewMode}`);

    const handleGalleryComplete = () => {
    };

    return (
        <>
            <PhotoGalleryPage
                restaurantName={restaurantName}
                onComplete={handleGalleryComplete}
            />
        </>
    );
}

export default App;